import React from 'react';
import clsx from 'clsx';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ id, label, error, hint, className, ...props }, ref) => {
    const inputId = id || props.name;
    const helpId = inputId ? `${inputId}-help` : undefined;

    return (
      <div className='space-y-1.5'>
        {label ? (
          <label
            htmlFor={inputId}
            className='block text-sm font-semibold text-secondary-700 dark:text-secondary-200'
          >
            {label}
          </label>
        ) : null}
        <input
          ref={ref}
          id={inputId}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={error || hint ? helpId : undefined}
          className={clsx(
            'min-h-11 w-full rounded-lg border bg-white px-3 text-sm text-secondary-900 shadow-sm',
            'placeholder:text-secondary-400 focus:outline-none focus:ring-2',
            'disabled:cursor-not-allowed disabled:bg-secondary-100 disabled:text-secondary-500',
            'dark:bg-secondary-900 dark:text-white dark:disabled:bg-secondary-800',
            error
              ? 'border-danger-400 focus:border-danger-500 focus:ring-danger-200 dark:border-danger-700'
              : 'border-secondary-300 focus:border-primary-500 focus:ring-primary-200 dark:border-secondary-700',
            className
          )}
          {...props}
        />
        {error || hint ? (
          <p
            id={helpId}
            className={clsx(
              'text-xs',
              error
                ? 'text-danger-600 dark:text-danger-300'
                : 'text-secondary-500 dark:text-secondary-400'
            )}
          >
            {error || hint}
          </p>
        ) : null}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
